module.exports = __webpack_public_path__ + "assets/img/Group_302.b731b0c8.png";